import { useQuery } from "@tanstack/react-query";
import { API_URL_RETAILER_VALIDATE_SIM_NUMBER } from "../../api";
import { retailerFetch } from "../../retailerFetch";

export interface SimNumberCheckResult {
    inUse: boolean;
}

const fetchSimNumberCheck = async (iccid: string): Promise<SimNumberCheckResult> => {
    const url = new URL(API_URL_RETAILER_VALIDATE_SIM_NUMBER, window.location.href);
    url.searchParams.set("iccid", iccid);

    const res = await retailerFetch(url.toString());
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error((json as { error?: string }).error ?? "Kunne ikke sjekke SIM-nummeret");
    }
    return res.json() as Promise<SimNumberCheckResult>;
};

export const useSimNumberCheck = (iccid: string, enabled = true) => {
    return useQuery({
        queryKey: ["simNumberCheck", iccid],
        queryFn: () => fetchSimNumberCheck(iccid),
        enabled,
        retry: false,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
};
